/* eslint-disable camelcase */
import Banner from 'app/components/partials/banner';
import ContentBlocks from 'app/components/content-blocks/index';
import PropTypes from 'prop-types';
import Strip from 'app/components/partials/strip';
import React, { useEffect, useRef, useState } from 'react';

const Home = ({ data }) => {
    const [isStripActive, setIsStripActive] = useState(false);
    const {
        blocks,
        thumbnail,
        name: title,
        main_images: mainImages,
        short_description: description,
        hero_video: heroVideo
    } = data;

    const heroCarouselRef = useRef(null);

    const checkHeroCarouselInView = () => {
        const heroCarouselOffset = heroCarouselRef.current.getBoundingClientRect();
        if (heroCarouselOffset.top < 0 && heroCarouselOffset.bottom < 0) return setIsStripActive(false);

        setIsStripActive(true);
    };

    useEffect(() => {
        checkHeroCarouselInView();
        window.addEventListener('scroll', checkHeroCarouselInView);

        return () => window.removeEventListener('scroll', checkHeroCarouselInView);
    }, []);

    return (
        <div className="content-page">
            <Banner
                description={description}
                mainImages={mainImages}
                title={title}
                thumbnail={thumbnail}
                primary={true}
                ref={heroCarouselRef}
                heroVideo={heroVideo}
            />
            <ContentBlocks data={blocks} />
            <Strip isActive={isStripActive} />
        </div>
    );
};

Home.propTypes = {
    data: PropTypes.shape({
        blocks: PropTypes.array,
        thumbnail: PropTypes.string,
        name: PropTypes.string.isRequired,
        main_images: PropTypes.array,
        short_description: PropTypes.string,
        hero_video: PropTypes.string
    }).isRequired
};

export default Home;

